import * as React from "react";

// Top-view potted plant - circular pot with leaves radiating from center
function PlantIcon({ color = "#4CAF50", width = 40, height = 40, name }) {
  return (
    <div style={{ textAlign: "center" }}>
      {name && <p style={{ margin: 0, fontSize: "10px", userSelect: "none" }}>{name}</p>}
      <svg
        viewBox="0 0 100 100"
        height={height}
        width={width}
      >
        {/* Pot rim - brown circle */}
        <circle cx="50" cy="50" r="45" fill="#8B4513" />
        <circle cx="50" cy="50" r="38" fill="#A0522D" />
        {/* Soil */}
        <circle cx="50" cy="50" r="32" fill="#3E2723" />
        {/* Leaves radiating from center - top view */}
        <ellipse cx="50" cy="30" rx="12" ry="18" fill={color} transform="rotate(0 50 50)" />
        <ellipse cx="50" cy="30" rx="12" ry="18" fill={color} transform="rotate(60 50 50)" />
        <ellipse cx="50" cy="30" rx="12" ry="18" fill={color} transform="rotate(120 50 50)" />
        <ellipse cx="50" cy="30" rx="12" ry="18" fill={color} transform="rotate(180 50 50)" />
        <ellipse cx="50" cy="30" rx="12" ry="18" fill={color} transform="rotate(240 50 50)" />
        <ellipse cx="50" cy="30" rx="12" ry="18" fill={color} transform="rotate(300 50 50)" />
        {/* Center */}
        <circle cx="50" cy="50" r="8" fill="#2E7D32" />
      </svg>
    </div>
  );
}

export default PlantIcon;
